import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { attemptLogin, clearMessage, failedLogin, successfullLogin } from '../actions/auth.actions';
import { catchError, exhaustMap, finalize, map, tap } from 'rxjs';
import { Credentials } from '../../models/credentials';
import { AuthService } from '../../services/auth.service';
import { User } from 'src/app/core/models/users';
import { Store } from '@ngrx/store';
import { unsetLoading } from 'src/app/loading/state/actions/loading.actions';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private authSvc = inject(AuthService);
  private store = inject(Store);
  private readonly translateService = inject(TranslateService);

  attemptLogin$ = createEffect(() =>
    { return this.actions$.pipe(
      ofType(attemptLogin),
      map((action: any) => action.credentials),
      exhaustMap((credentials: Credentials) => {
        return this.authSvc.checkCredentials(credentials.username, credentials.password).pipe(
          map((resp: any) => {
            const user = resp.body as User.User;
            const authToken = resp?.headers?.get('auth-token') ?? '';
            user.authenticated = true;

            return successfullLogin({ user: { ...user, authToken } });
          }),
          catchError(async (err: any) => {
            // eslint-disable-next-line @ngrx/no-dispatch-in-effects
            this.store.dispatch(unsetLoading());

            switch (err.status) {
              case 401:
                return failedLogin({
                  errorMessage: this.translateService.instant('SIGNIN.INVALID_CREDENTIALS'),
                });
              case 429:
                return failedLogin({
                  errorMessage: this.translateService.instant('SIGNIN.ABNORMAL_ACTIVITIES'),
                });

              case 0:
                return failedLogin({ errorMessage: this.translateService.instant('SIGNIN.OFFLINE_ERROR') });
              default:
                return failedLogin({
                  errorMessage: this.translateService.instant('SIGNIN.GENERIC_ERROR'),
                });
            }
          }),
          // eslint-disable-next-line @ngrx/no-dispatch-in-effects
          finalize(() => this.store.dispatch(clearMessage()))
        );
      })
    ) }
  );
}
